module.exports = __webpack_public_path__ + "static/media/no-access.b697c336.png";